<script lang="ts">
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import SectionBoard from "../../molecules/SectionBoard.svelte";

  export let klass = "";
  let loading = false;

  const sendTest = async () => {
    const client = ApiService.createClient();
    loading = true;
    const { data } = await client.post("/mail/send", {
      subject: "テスト送信",
      text: "テスト送信に成功しました。",
      html: "テスト送信に成功しました。",
    });
    console.log(data);
    loading = false;
  };
</script>

<SectionBoard {klass}>
  <h2 class="font-semibold">メール送信テスト</h2>

  <div class="text-gray-500 text-sm mt-4">
    メールの送信テストを行います。<br />
    送信設定・受信設定が保存されている必要があります。
  </div>

  <BlueButton rounded klass="mt-4" click={sendTest} {loading}>
    送信する
  </BlueButton>
</SectionBoard>
